import React from 'react';
import { colour_lookup } from '../../common/Colours';
import { StyledCustomEvent, EventTitle } from '../../common/styles/devices/Calendar';

const format24Hours = (dateObj: Date) => {
  return `${dateObj.getHours().toString().padStart(2, '0')}:${dateObj.getMinutes().toString().padStart(2, '0')}`;
}

export const CustomEvent = (props) => {
  var event_end = format24Hours(props.event.end);
  if (event_end == '23:59') event_end = '00:00';
  return (
    props.event.duration >= 3600?
      <StyledCustomEvent>
        {`${format24Hours(props.event.dtstart)} - ${event_end}`}
        {props.event.duration >= 7200 &&
          <EventTitle>{props.event.ruleTitle}</EventTitle>}
      </StyledCustomEvent>
    :
      <StyledCustomEvent></StyledCustomEvent>
  )
}

export const CustomEventWrapper = (props) => {
  
  // console.log(props);
  
  let style: any = {
    top: `${props.style.top}%`,
    left: `${props.style.left}%`,
    width: `${props.style.width}%`,
    height: `${props.style.height}%`,
    background: props.event.style.background
  }
  
  if (props.event.duration >= 3600) {
    
    if (props.event.focus) {
      if (props.event.saved) {
        style.border = `3px solid  ${props.event.style.border}`;
      } else {
        style.border = `3px dashed  ${props.event.style.border}`;
      }
    } else {
      if (props.event.saved) {
        style.border = `1px solid  ${props.event.style.border}`;
      } else {
        style.border = `2px dashed  ${props.event.style.border}`;
      }
    }
    
    if (props.event.overlapping) {
      style.border = `3px solid ${colour_lookup('red')}`;
    }
    
  }
  
  if (props.event.duration < 3600) {
    style.height = 0.065 * (props.event.duration / 60) + '%';
    style.width = '100%';
  }
  
  // console.log(style)
  
  return (
    <div onClick={e => props.onClick(props.event, e)} className="rbc-event" style={style}>{props.components.event(props)}</div>
  )
}